import { ColorVariant } from '../../../components'
import { getColor } from '../utils'

export function getSurpriseDotColor(value: number) {
  let color = ColorVariant.gray
  if (value > 0) {
    color = ColorVariant.green
  } else if (value < 0) {
    color = ColorVariant.red
  }

  return getColor(color)
}
